//fill the cart (page) with vue, and handle all actions
import Datepicker from "vuejs-datepicker";
import { nl } from "vuejs-datepicker/dist/locale";
import * as SPINNER from "../helpers/spinner";
import DataLayerEvent from "../gtm/DataLayerEvent";
import { data } from "jquery";

window.onpageshow = function (event) {
    if (event.persisted) {
        window.location.reload();
    }
};

if ($("#cart").length) {
    const cart = new Vue({
        el: "#cart",
        components: {
            Datepicker,
        },
        data: {
            cart: {},
            card_fonts: {},
            card_limit: 450,
            errors: {},
            disabled: true,
            unsaved_selection: true,
            all_available: true,
            nl: nl,
            zipcode_check_countrys: ["NL"],
        },
        created: function () {
            SPINNER.showSpinner();
            this._getData();
        },
        mounted: () => {
            if ($(".datepicker").length) {
                $(".datepicker").datepicker({
                    format: "dd/mm/yyyy",
                });
            }
        },
        methods: {
            changeQuantity: function (item, amount) {
                if (item.debounce) {
                    clearTimeout(item.debounce);
                }

                if (amount) {
                    item.quantity = item.quantity + amount;
                }
                if (item.quantity <= 0 && item.quantity !== undefined) {
                    item.quantity = 1;
                }

                item.debounce = setTimeout(() => {
                    this.$http
                        .post(
                            "/ajax/cart/update-quantity/" + item.selection_key,
                            {
                                quantity: item.quantity,
                            }
                        )
                        .then(() => {
                            this._getData();
                            const dataLayerEvent = new DataLayerEvent();
                            const eventType =
                                amount > 0 ? "add_to_cart" : "remove_from_cart";
                            dataLayerEvent.addEvent(
                                eventType,
                                item.product,
                                item.quantity,
                                item.product.price_per_unit
                            );
                        });
                }, 400);
            },
            changeSelection: function (item) {
                this.removeErrors(item.selection_key);
                this.$http
                    .post("/ajax/cart/update-selection/" + item.selection_key, {
                        selection: item.selection,
                    })
                    .then(() => {
                        this._getData();
                        $("html, body").animate(
                            {
                                scrollTop:
                                    $("#collapse" + item.selection_key)
                                        .closest("li")
                                        .offset().top -
                                    $("header").outerHeight(),
                            },
                            500
                        );
                    })
                    .catch((err) => {
                        const errors = err?.response?.data?.errors; // Safely access nested properties
                        if (errors) {
                            this.showErrors(errors, item.selection_key);
                        } else {
                            console.error("Unexpected error structure:", err);
                            this.showErrors(
                                ["An unexpected error occurred"],
                                item.selection_key
                            );
                        }
                    });
            },
            remove: function (item) {
                if (
                    confirm(
                        "Weet u zeker dat u dit item uit uw winkelwagen wilt verwijderen"
                    )
                ) {
                    this.$http
                        .delete("/ajax/cart/remove/" + item.selection_key)
                        .then(() => {
                            this._getData();
                            const dataLayerEvent = new DataLayerEvent();
                            dataLayerEvent.addEvent(
                                "remove_from_cart",
                                item.product,
                                item.quantity,
                                item.total_price
                            );
                        });
                }
            },
            clearCart: function () {
                if (
                    confirm(
                        "Weet u zeker dat u alle items uit uw winkelwagen wilt verwijderen?"
                    )
                ) {
                    const dataLayerEvent = new DataLayerEvent();
                    dataLayerEvent.addEvent(
                        "remove_from_cart",
                        this.cart.items,
                        this.cart.total_items,
                        this.cart.total_price
                    );
                    this.$http.delete("/ajax/cart/clear").then(() => {
                        this._getData();
                    });
                }
            },
            showErrors: function (errors, selection_key) {
                this.errors = errors;
                $.each(errors, function (key, error) {
                    const error_key = String(key)
                        .replace("address.", "")
                        .replace("selection.", "")
                        .replace("card.", "");
                    let input_field = $("#" + error_key + selection_key);
                    let error_html =
                        "<div class='text-danger' id=" +
                        "error-" +
                        error_key +
                        "-" +
                        selection_key +
                        ">" +
                        error +
                        "</div>";
                    if (error_key === "type_of_box") {
                        input_field.find("label").addClass("text-danger");
                    } else {
                        input_field.addClass("border border-danger");
                    }
                    input_field.after(error_html);
                });
                $("html, body").animate(
                    {
                        scrollTop:
                            $("#collapse" + selection_key)
                                .closest("li")
                                .offset().top - $("header").outerHeight(),
                    },
                    500
                );
            },
            removeErrors: function (selection_key) {
                $.each(this.errors, function (key) {
                    const error_key = String(key)
                        .replace("address.", "")
                        .replace("selection.", "")
                        .replace("card.", "");
                    let input_field = $("#" + error_key + selection_key);
                    input_field.removeClass("border border-danger");
                    input_field.find("label").removeClass("text-danger");
                    $("#error-" + error_key + "-" + selection_key).remove();
                });
            },
            _getData: function () {
                SPINNER.showSpinner();
                const vm = this;

                this.$http.get("/ajax/cart/content").then((response) => {
                    this.cart = response.data;
                    this.all_available = true;
                    this.checkSavedSelections();
                    $.each(this.cart.items, function (key, item) {
                        item.disabled_dates = {};

                        if (item.selection.shipping_method) {
                            item.is_pickup = item.selection.shipping_method
                                .pickup
                                ? true
                                : false;
                        } else {
                            item.is_pickup = false;
                        }

                        if (item.selection.sendWithHelium) {
                            if (
                                typeof disabled_days !== "undefined" &&
                                typeof disabled_days === "object"
                            ) {
                                vm.setDisabledDays(item, disabled_days);
                            }
                            vm.getShippingMethods(
                                item,
                                item.selection.address.country,
                                item.selection.address.zipcode
                            );
                        }
                        if (!item.available) {
                            vm.all_available = false;
                            vm.disabled = true;
                        }

                        if (item.selection.address) {
                            if (
                                item.selection.address.street_name &&
                                item.selection.address.country
                            ) {
                                item.zipcode_check = true;
                                item.zipcode_readonly = true;
                            }

                            if (!item.selection.address.delivery_type) {
                                item.selection.address.delivery_type =
                                    vm.cart.default_delivery_type;
                            }
                        }
                    });
                    getCartProductsCount();
                    SPINNER.hideSpinner();
                });
            },
            changeFont: function (item, font) {
                item.selection.selection_saved = false;
                this.checkSavedSelections();
                item.selection.card.font = font;
                this.$forceUpdate();
            },
            changeCountry: function (item, country) {
                item.selection.selection_saved = false;
                this.checkSavedSelections();

                if (!this.zipcode_check_countrys.includes(country)) {
                    item.zipcode_check = true;
                    item.zipcode_readonly = false;
                } else if (
                    !item.selection.address.street &&
                    !item.selection.address.city
                ) {
                    item.zipcode_check = false;
                } else {
                    item.zipcode_check = true;
                    item.zipcode_readonly = true;
                }

                this.$forceUpdate();
                this.getShippingMethods(item, country);
            },
            changeShippingMethod: function (item, method) {
                item.selection.selection_saved = false;
                this.checkSavedSelections();
                item.selection.delivery_date = method.delivery_date;
                item.disabled_dates.days = method.disabled_days;
                item.disabled_dates.to = new Date(item.selection.delivery_date);
                if ($(".vdp-datepicker__calendar header .next")[0]) {
                    $(".vdp-datepicker__calendar header .next")[0].click();
                    $(".vdp-datepicker__calendar header .prev")[0].click();
                }
            },
            changePickup: function (item, is_pickup) {
                item.selection.selection_saved = false;
                this.checkSavedSelections();
                item.is_pickup = is_pickup;
                this.$forceUpdate();
                this.getShippingMethods(item);
            },
            changePickupLocation: function (item, location) {
                item.selection.selection_saved = false;
                this.checkSavedSelections();
                item.selection.pickup_location = location;
                this.$forceUpdate();
            },
            selectionChanged: function (item, getShippingMethods = false) {
                if (typeof item.selection.delivery_date == "object") {
                    item.selection.delivery_date =
                        item.selection.delivery_date.toUTCString();
                }
                item.selection.selection_saved = false;

                this.checkSavedSelections();
                if (getShippingMethods) {
                    this.getShippingMethods(item);
                }
                this.$forceUpdate();
            },
            zipcodeCheck: function (item, address) {
                SPINNER.showSpinner();
                if (address.country === "NL") {
                    if (
                        address.zipcode &&
                        address.zipcode.length >= 6 &&
                        address.house_number != null
                    ) {
                        this.getAddress(
                            item,
                            address,
                            address.zipcode,
                            address.house_number,
                            address.country
                        );
                        this.getShippingMethods(
                            item,
                            address.country,
                            address.zipcode
                        );
                    }
                }
                // else if(address.country === "BE") {
                //     if ((address.zipcode && address.zipcode.length >= 4) && address.house_number != null) {
                //         this.getAddress(item, address, address.zipcode, address.house_number, address.country);
                //     }
                // }
                else {
                    item.zipcode_check = true;
                }
                this.$forceUpdate();
                SPINNER.hideSpinner();
            },
            getShippingMethods: function (
                item,
                country = "NL",
                zipcode = "0",
                company = 0
            ) {
                let has_same_day_delivery = item.product.has_same_day_delivery
                    ? 1
                    : 0;
                let is_pickup_only = item.product.is_pickup_only ? 1 : 0;

                let selected_delivery_type = item.is_pickup
                    ? "pickup"
                    : item.selection.address.delivery_type ?? "home_address";
                company = this.companyCheck(item);
                country = item.selection.address.country;
                if (item.selection.address.zipcode) {
                    zipcode = item.selection.address.zipcode
                        ? item.selection.address.zipcode
                        : "0";
                }
                axios
                    .get(
                        "/ajax/shippingmethods/" +
                            country +
                            "/" +
                            zipcode +
                            "/" +
                            has_same_day_delivery +
                            "/" +
                            company +
                            "/" +
                            is_pickup_only +
                            "/" +
                            selected_delivery_type,
                        {}
                    )
                    .then((res) => {
                        let vm = this;
                        item.shipping_methods = res.data.filter((method) => {
                            return item.is_pickup == method.pickup;
                        });

                        if (!item.selection.selection_saved) {
                            let selected_method = item.shipping_methods.find(
                                (method) =>
                                    method.type ==
                                    item.selection.shipping_method.type
                            );

                            if (!selected_method) {
                                if (
                                    item.shipping_methods.find(
                                        (method) =>
                                            method.type == "default" ||
                                            method.type ==
                                                "default_wholesale" ||
                                            method.type == "pickup"
                                    )
                                ) {
                                    selected_method =
                                        item.shipping_methods.find(
                                            (method) =>
                                                method.type == "default" ||
                                                method.type ==
                                                    "default_wholesale" ||
                                                method.type == "pickup"
                                        );
                                } else {
                                    selected_method = item.shipping_methods[0];
                                }
                            }

                            item.selection.shipping_method = selected_method;
                            item.selection.delivery_date = new Date(
                                selected_method.delivery_date
                            );
                            item.disabled_dates.days =
                                selected_method.disabled_days;
                            item.disabled_dates.to = new Date(
                                selected_method.delivery_date
                            );

                            if (
                                new Date(item.selection.delivery_date) <
                                new Date(selected_method.delivery_date)
                            ) {
                                item.selection.delivery_date = new Date(
                                    selected_method.delivery_date
                                );
                            }
                        } else {
                            let selected_method = item.shipping_methods.find(
                                (method) =>
                                    method.type ==
                                    item.selection.shipping_method.type
                            );
                            if (!selected_method) {
                                selected_method = item.shipping_methods.find(
                                    (method) =>
                                        method.type == "default" ||
                                        method.type == "default_wholesale" ||
                                        method.type == "pickup"
                                );
                            }
                            item.selection.shipping_method = selected_method;
                            item.disabled_dates.days =
                                selected_method.disabled_days;
                            item.disabled_dates.to = new Date(
                                selected_method.delivery_date
                            );

                            if (
                                new Date(item.selection.delivery_date) <
                                new Date(selected_method.delivery_date)
                            ) {
                                item.selection.delivery_date = new Date(
                                    selected_method.delivery_date
                                );
                                item.selection.selection_saved = false;
                                this.checkSavedSelections();
                            }
                        }

                        this.setDisabledDays(item, disabled_days);
                    });
            },
            getAddress: function (
                item,
                address,
                zipcode,
                houseNumber,
                country
            ) {
                const vm = this;
                axios
                    .post("/ajax/zipcode", {
                        zipcode,
                        houseNumber,
                        country,
                    })
                    .then((res) => {
                        const data = res.data;

                        if (data.street && data.city) {
                            address.street_name = data.street;
                            address.city = data.city;
                            item.zipcode_readonly = true;
                            item.zipcode_not_found = false;
                        } else {
                            address.street_name = "";
                            address.city = "";
                            item.zipcode_readonly = false;
                            item.zipcode_not_found = true;
                        }
                        item.zipcode_check = true;
                        vm.$forceUpdate();
                    })
                    .catch((error) => {
                        address.street_name = "";
                        address.city = "";
                        item.zipcode_readonly = false;
                        item.zipcode_check = true;
                        item.zipcode_not_found = false;
                        vm.$forceUpdate();
                    });
            },
            changeAddress: function (item) {
                item.zipcode_readonly = false;
                this.$forceUpdate();
            },
            checkSavedSelections: function () {
                const vm = this;
                vm.disabled = false;
                vm.unsaved_selection = false;
                $.each(this.cart.items, function (key, item) {
                    if (item.selection.sendWithHelium) {
                        if (!item.selection.selection_saved) {
                            vm.disabled = true;
                            vm.unsaved_selection = true;
                        }
                    }
                });
            },
            currency: function (value) {
                return (
                    "€ " +
                    parseFloat(value)
                        .toFixed(2)
                        .replace(".", ",")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                );
            },
            setDisabledDays: function (item, disabled_days) {
                item.disabled_dates.dates = [];
                $.each(
                    disabled_days[item.selection.address.country],
                    function (key, day) {
                        item.disabled_dates.dates.push(new Date(day));
                    }
                );
                item.disabled_dates.days =
                    item.selection.shipping_method.disabled_days;
                item.disabled_dates.to = new Date(
                    item.selection.shipping_method.delivery_date
                );
            },
            companyCheck(item) {
                if (item.selection.address.delivery_type) {
                    return item.selection.address.delivery_type !==
                        this.cart.default_delivery_type
                        ? 1
                        : 0;
                }

                return 0;
            },
        },
    });
}
